import datepicker from '../../../../../modules/Gull/Framework/datepicker.js';

const edit = {

	init() {
		// Toon of verberg het blok voor overlappend nrp op basis van de begindatum voor een nieuw nrp en de einddatum van reeds bestaande nrp.
		$('#Begindatum, #Einddatum, #noriskSoort').change(function(e) {
			e.preventDefault();
			if ($('#Begindatum').val() != '' && $('#noriskSoort').val() != '') {
				$.getJSON(document.URL + '/duplicate-check/' + $('#Begindatum').val() + '/' + $('#Einddatum').val() + '/' + $('#noriskSoort').val() + '/' + $('#form-noriskpolis').attr('noriskpolis_id') + '/', function(data) {
					if (data != false) {
						// Er is een overlappend nrp
						if (!$('#form_suggestion').is(':visible')) {
							$('#form_suggestion').hide().removeClass('d-none').fadeIn();
							$('#form_continue').hide();
						}

						$('.gevonden-noriskpolissen *').remove();
						$.each(data, function(index, val) {
							var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + $('#noriskSoort option[value="' + val.contract + '"]').text() + '</td><td>' + val.action + '</td></tr>';
							$('.gevonden-noriskpolissen').append(tr);
						});
					} else {
						// Er is nog geen overlappend nrp
						edit.hideFormSuggestion();
					}
				});
			}
		});

		// laad de datum kiezer voor einddatum op basis van de begindatum
		$('#Begindatum').change(function(e) {
			e.preventDefault();
			$('input#Einddatum').attr('data-enddate', $('input#Begindatum').attr('data-enddate'));
			$('input#Einddatum').attr('data-startdate', $('input#Begindatum').val());
		});
		$('#Begindatum').trigger('change');

		// Toon of verberg einddatum na het selecteren van een soort.
		$('#noriskSoort').change(function(e) {
			e.preventDefault();
			if ($(this).val().toLowerCase() != 'wajong') {
				$('input#Einddatum').attr('data-validate', 'required date daterange').val($('input#Einddatum').attr('valueOrg')).closest('.form-group').removeClass('d-none');
				// $('input#Einddatum').datepicker('update');  // omgezet naar onderstaande regel wegens error na bundling waardoor verkeerde datum opmaak werd gebruikt
				$('input#Einddatum').datepicker(datepicker.settings.date, 'update');
			} else {
				$('input#Einddatum').val('').attr('data-validate', '').closest('.form-group').addClass('d-none');
			}
		});
		$('#noriskSoort').trigger('change');
	},

	// Verberg het blok voor overlappend nrp
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	}

};

export default edit;
